import React, { Component } from "react"
import { Link, graphql } from "gatsby"
import AOS from 'aos'
import WPAPI from 'wpapi';
import Layout from "../layouts"
import Lottie from 'react-lottie';
import VideoElement from "../components/Video/Video";
import { Helmet } from "react-helmet"

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("progress-bar").style.width = scrolled + "%";
}

function uniq(a) {
    return a.sort().filter(function(item, pos, ary) {
        return !pos || item != ary[pos - 1];
    })
}

function escapeHtml(str){
    var map ={
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return str.replace(/[&<>"']/g, function(m) {return map[m];});
}

var loadingData = {"v":"5.6.1","fr":30,"ip":0,"op":82,"w":1258,"h":1457,"nm":"loader-loop","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"orange 1","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[631,728,0],"ix":2},"a":{"a":0,"k":[629,728,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":15,"op":30,"st":15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"orange 1","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":0,"op":15,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 4","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 3","cl":"1","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').end;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 2","cl":"1","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1]","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Orange Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Orange Line/Excel_Monogram_Loader Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1259,1456.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-99.673,0],[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0]],"o":[[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0],[-99.673,0],[0,0],[0,0]],"v":[[-466.5,-161],[-466.5,385.527],[-286.027,566],[286.027,566],[466.5,385.527],[466.5,-385.527],[286.027,-566],[-286.027,-566],[-466.5,-385.527],[-466.5,161]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.917647058824,0.588235294118,0.160784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":65,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[52]},{"t":15,"s":[6]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"t":15,"s":[54]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":15,"st":-15,"bm":0}]},{"id":"comp_2","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Right Arrow Mask/Excel_Monogram_Loader Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":90,"ix":10},"p":{"a":0,"k":[61.75,74.25,0],"ix":2},"a":{"a":0,"k":[34,50,0],"ix":1},"s":{"a":0,"k":[125,125,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0]],"o":[[0,0]],"v":[[-0.375,76.375]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.639215985466,0.917646998985,0.831372967888,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.477,-1.476],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,-2.088],[0,0],[0,0],[1.477,-1.477],[0,0],[0,0]],"v":[[34.068,-49.566],[34.068,-48.88],[1.232,-16.052],[-31.55,-48.835],[-31.55,-49.566],[-32,-49.566],[-31.6,15.816],[-27.549,20.784],[1.232,49.566],[30.067,20.734],[35,15.746],[35,-49.566]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[33.308,49.015],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":98,"st":0,"bm":0}]},{"id":"comp_3","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"blue 1","refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[631,728,0],"ix":2},"a":{"a":0,"k":[629,728,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":15,"op":30,"st":15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"blue 1","refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":0,"op":15,"st":0,"bm":0}]},{"id":"comp_4","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 4","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 3","cl":"1","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').end;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 2","cl":"1","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1]","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Blue Line/Excel_Monogram_Loader Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1259,1456.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-99.673,0],[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0]],"o":[[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0],[-99.673,0],[0,0],[0,0]],"v":[[-466.5,-161],[-466.5,385.527],[-286.027,566],[286.027,566],[466.5,385.527],[466.5,-385.527],[286.027,-566],[-286.027,-566],[-466.5,-385.527],[-466.5,161]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.238999998803,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":65,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[52]},{"t":15,"s":[6]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"t":15,"s":[54]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":15,"st":-15,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"orange arrow - 1","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":41,"s":[0]},{"t":82,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":41,"op":82,"st":41,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"blue arrow - 1","refId":"comp_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":41,"s":[0]},{"t":82,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":41,"op":82,"st":41,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"orange arrow - 1","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":41,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":0,"op":41,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"blue arrow - 1","refId":"comp_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":41,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":0,"op":41,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"E","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[282.5,375.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[1.475,-1.476],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[2.088,0],[0,0]],"o":[[0,0],[2.088,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[1.476,1.477],[0,0],[0,0]],"v":[[-282.208,-374.944],[256.917,-374.944],[258.575,-370.944],[129.625,-241.972],[-135.837,-241.972],[-135.837,-65.455],[131.179,-65.455],[196.605,-0.024],[131.134,65.455],[-135.837,65.455],[-135.837,241.948],[151.757,241.948],[280.732,370.943],[279.075,374.944],[-282.208,374.944]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.043000000598,0.109999997008,0.238999998803,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[282.458,375.194],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":159,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":1,"nm":"White Solid 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"sw":1258,"sh":1457,"sc":"#ffffff","ip":0,"op":150,"st":0,"bm":0}],"markers":[]};

class University extends Component {

  componentDidMount() {
    AOS.init();

    window.onscroll = function() {
      myFunction();
      AOS.refresh();
    };
  }

  constructor () {
    super();
    this.state = {
      password: '',
      passwordInvalid: false,
      validatedData: [],
      username: '',
      userData: [],
      toggleData: false,
      loading: false,
      overlayTitle: '',
      overlayBody: '',
      loggedInUserData: '',
      overlayPDForVideo: '',
      overlayPosterImage: '',
      overlaySourceURL: '',
      overlayActive: false
    };

    this.activateLoading   = this.activateLoading.bind(this);
    this.deactivateLoading = this.deactivateLoading.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.closeOverlay = this.closeOverlay.bind(this);
    this.updateData = this.updateData.bind(this);
  }

  parseJSON(response){
    return response.text().then(function(text) {
      return text ? JSON.parse(text) : {}
    })
  }


  deactivateLoading(){
    this.setState({
      loading: false
    })
  }

  activateLoading(){
    this.setState({
      loading: true
    })
  }


  validateLogin(email){
    console.log(email)
    this.activateLoading();
    this.setState({ 
      loading: true
    })
    if (email === ""){
      this.deactivateLoading();
      this.setState({ 
          passwordInvalid: true
        })
    }else{
      var apiPromise = WPAPI.discover( 'https://admin.excelinstore.com/' ).then(function( site ) {
        return site.auth({
          endpoint: 'https://admin.excelinstore.com/wp-json',
          username: email,
          password: 'Tony#Stark0w',
        });
      });

      apiPromise.then((site) => {
        site.users().me().get((err, userData) => {
          if ( err ) {
            this.deactivateLoading();
            this.setState({ 
              passwordInvalid: true
            })
          }
          if (userData){
            let profiledata = userData;
            window.scrollTo(0, 0);
            AOS.init();
            AOS.refresh();

            this.setState({ 
              validatedData: this.props.data.allWordpressWpUniversity.edges,
              loggedInUserData: userData,
              toggleData: true,
              loading: false,
              username: email
            })

            setTimeout(() => {
                this.setState({
                  loading: false
                })
            }, 800);
          }else{
            this.setState({ 
              validatedData: [],
              loading: false,
              passwordInvalid: true
            })
          }
        });
      });

    }
  }

  handleSubmit(e){
    let element = document.getElementById('emailAddressFormID');
    e.preventDefault();
    this.validateLogin(element.value);
  }

  onKeyDown(e){

    this.handlePasswordChange(e);
    if (e.key === 'Enter'){
      e.preventDefault();
      this.validateLogin(e.target.value);
    }
  }

  updateData(id, title, data){

    if(this.state.loggedInUserData.meta.data == "" || this.state.loggedInUserData.meta.data == '""' || this.state.loggedInUserData.meta.data == '"\"\"' || this.state.loggedInUserData.meta.data == '"\"\"\"\""' || this.state.loggedInUserData.meta.data == '"\"\"\"\"\"\""' || this.state.loggedInUserData.meta.data == 'null'){

      let NewArr = []
      
      this.props.data.allWordpressWpUniversity.edges.map(( resource, i) => {
        let NewObj = {
          id: resource.node.wordpress_id,
          watched: false
        }
        NewArr.push(NewObj)
      });

      console.log(NewArr)


      let uniqueAddresses = Array.from(new Set(NewArr.map(a => a.id)))
       .map(id => {
         return NewArr.find(a => a.id == id)
       })

       uniqueAddresses.map(( obj, i) => {
        console.log('watched?')
        console.log(obj.id == id)
        if(obj.id == id){
          uniqueAddresses[i]['watched'] = true
          console.log(uniqueAddresses[i])
        }
      })

       console.log(uniqueAddresses)


      var apiPromise = WPAPI.discover( 'https://admin.excelinstore.com' ).then( (site) => {
        return site.auth({
          endpoint: 'https://admin.excelinstore.com/wp-json',
          username: this.state.username,
          password: 'Tony#Stark0w',
        });
      });

      apiPromise.then((site) => {
        site.users().me().update({
          meta:{
            data: JSON.stringify(uniqueAddresses)
          }
        }).then(response => {
          console.log(NewArr)
          this.setState({
            loggedInUserData: response
          })
        }).catch((err) => {
          console.log( err );
        });
      });
    }else{

      let manipulatedData = JSON.parse(this.state.loggedInUserData.meta.data)

      let newManipulatedData = []

      let dogs = []

      this.props.data.allWordpressWpUniversity.edges.map(( media, i) => {
        let dog = manipulatedData.find(x => x.id === media.node.wordpress_id);

        if(dog == undefined){
          let NewObj = {
            id: media.node.wordpress_id,
            watched: false
          }
          newManipulatedData.push(NewObj)
        }else{
          newManipulatedData.push(dog)
        }
      })

      console.log(newManipulatedData);

      let uniqueAddresses = Array.from(new Set(newManipulatedData.map(a => a.id)))
       .map(id => {
         return newManipulatedData.find(a => a.id === id)
       })


      uniqueAddresses.map(( obj, i) => {
        console.log('watched?')
        console.log(obj.id == id)
        if(obj.id == id){
          uniqueAddresses[i]['watched'] = true
          console.log(uniqueAddresses[i])
        }
      })


      var apiPromise = WPAPI.discover( 'https://admin.excelinstore.com' ).then( (site) => {
        return site.auth({
          endpoint: 'https://admin.excelinstore.com/wp-json',
          username: this.state.username,
          password: 'Tony#Stark0w',
        });
      });

      console.log(uniqueAddresses)

      apiPromise.then((site) => {
        site.users().me().update({
          meta:{
            data: JSON.stringify(uniqueAddresses)
          }
        }).then(response => {
          // console.log(NewArr)
          console.log(response );
          this.setState({
            loggedInUserData: response
          })
        }).catch((err) => {
          console.log( err );
        });
      });

    }

    let bodyInformation = data
    let body = bodyInformation.wysiwyg
    let option = bodyInformation.video_or_pdf
    let poster = '';
    let media = '';
    if(bodyInformation.video.video !== null &&  bodyInformation.video.video_poster !== null){
      console.log('yes!')
      poster = bodyInformation.video.video_poster.url
      media = bodyInformation.video.video
    }
    if(poster == '' && bodyInformation.pdf_preview_image !== null ){
      poster = bodyInformation.pdf_preview_image.url
      media = bodyInformation.pdf_url
    }
    if(poster == ''){
      console.log('empty')
      poster = this.props.data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url
    }
    this.setState({ 
      overlayTitle: title,
      overlayBody: body,
      overlayPDForVideo: option,
      overlayPosterImage: poster,
      overlaySourceURL: media,
      overlayActive: true
    });
  

  }

  closeOverlay(){
    this.setState({ 
      overlayTitle: '',
      overlayBody: '',
      overlayPDForVideo: '',
      overlayPosterImage: '',
      overlaySourceURL: '',
      overlayActive: false
    });
  }


  handlePasswordChange (evt) {
    this.setState({ password: evt.target.value });
  }

  render() {
    const data = this.props.data

    const metaData = this.props.data.allWordpressAcfOptions.group[0].edges[0].node.options.meta_data_by_page.university

    let universityFilteredData = []
    let ultimateFilteredData = []
    let finalUltimateFilteredData = []
    let finalLoopedElements = []

    this.props.data.allWordpressWpUniversityCategories.edges.map(( edge, i) => {
      if(edge.node.wordpress_parent == 0){
        universityFilteredData.push(edge.node.wordpress_id)
      }
    });
    universityFilteredData.map(( edge, i) => {
      this.props.data.allWordpressWpUniversityCategories.edges.map(( edgeAll, i) => {
        if(edgeAll.node.wordpress_parent == edge){
          ultimateFilteredData.push(edgeAll.node.wordpress_parent)
        }
      });
    });

    universityFilteredData.map(( x, i) => {
      ultimateFilteredData.map(( y, i) => {
        if(x == y){
          // nothing
        }else{
          finalUltimateFilteredData.push(x)
        }
      });
    });

    let reducedArray = uniq(finalUltimateFilteredData)
    const validatedData = []

    let acfColor = '#F3A738'

    if (typeof window === 'undefined'){
      return (
        <Layout>
        <Helmet script={[{
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              "url": "https://excelinstore.com/",
              "name": "Excel | Moving Retail Forward",
              "author": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  },
                  "contactPoint": {
                      "@type": "ContactPoint",
                      "contactType": "customer support",
                      "telephone": "+1-218-998-3800",
                      "email": "contact@excelinstore.com"
                  }
              },
              "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
              "publisher": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  }
              }
            })
          }]}>
          <html lang="en" />
          <meta charSet="utf-8" />
          <title>Excel | University</title>
          <meta name="description" content={metaData.description} />
          <meta property="og:title" content={"Excel | University"}  />
          <meta property="og:type" content="WebSite" />
          <meta property="og:url" content="https://excelinstore.com/" />
          <meta property="og:image" content={metaData.image.url} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:description" content={metaData.description} />
          <meta property="og:site_name" content="Excel" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={"Excel | University" } />
          <meta name="twitter:description" content={metaData.description} />
          <meta name="twitter:image" content={metaData.image.url} />
          
        </Helmet>
        </Layout>
        )
    }else{
      var called = false
      window.addEventListener('mousedown', function() {
        if (called === false){
            let elem = document.getElementById('excel-global-header-inner')
            elem.classList.add('using-mouse');
            called = true
        }
      });

      return(
        <Layout>
        <Helmet script={[{
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              "url": "https://excelinstore.com/",
              "name": "Excel | Moving Retail Forward",
              "author": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  },
                  "contactPoint": {
                      "@type": "ContactPoint",
                      "contactType": "customer support",
                      "telephone": "+1-218-998-3800",
                      "email": "contact@excelinstore.com"
                  }
              },
              "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
              "publisher": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  }
              }
            })
          }]}>
          <html lang="en" />
          <meta charSet="utf-8" />
          <title>Excel | University</title>
          <meta name="description" content={metaData.description} />
          <meta property="og:title" content={"Excel | University"}  />
          <meta property="og:type" content="WebSite" />
          <meta property="og:url" content="https://excelinstore.com/" />
          <meta property="og:image" content={metaData.image.url} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:description" content={metaData.description} />
          <meta property="og:site_name" content="Excel" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={"Excel | University" } />
          <meta name="twitter:description" content={metaData.description} />
          <meta name="twitter:image" content={metaData.image.url} />
          
        </Helmet>
        <div className="progress"><div id="progress-bar" style={{backgroundColor: acfColor}}></div></div>
        <div className="university">
         {this.state.loading &&
            <div className="loading">
              <div className="loading-wrapper">
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: loadingData,
                    rendererSettings: {
                      preserveAspectRatio: 'xMidYMid slice'
                    }
                  }}
                />
              </div>
            </div>
          }
          {this.state.toggleData &&
            <div className="hero--wrapper university-hero">
              <div className="hero longest">
                <h1 className="micro" dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.preheadline}} data-aos="fade-up" data-aos-delay="400"/>
                <div className="title h2 longer portal no-marg" data-aos="fade-up" data-aos-delay="800" data-aos-anchor=".university-hero">Introducing an informational library for our dedicated partners.</div>
              </div>
            </div>
          }
          <div className={this.state.toggleData ? "hide-absolute hero--wrapper" : "hero--wrapper"}>
            <div className="hero longest">
              <h1 className="micro" dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.preheadline}} data-aos="fade-up" data-aos-delay="400"/>
              <div className="title h2 longer no-marg" data-aos="fade-up" data-aos-delay="800" data-aos-anchor=".hero">{data.allWordpressPage.edges[0].node.acf.headline}</div>
              { data.allWordpressPage.edges[0].node.acf.subheadline !== "" &&
                <div className="subtitle" data-aos="fade-up" data-aos-delay="1200" data-aos-anchor=".hero">{data.allWordpressPage.edges[0].node.acf.subheadline}</div>
              }
              { data.allWordpressPage.edges[0].node.acf.subheadline === "" &&
                <div className="spacer"></div>
              }
            </div>
          </div>
          <div className={this.state.toggleData ? "hide-absolute main-gutter margin-top-70": "main-gutter margin-top-70"} data-aos="fade-up" data-aos-delay="1200" data-aos-anchor=".hero">
            <div className="inner">
            <div className="grid-wrapper">
              <div className="grid lap-one-third">
                <div className="table-of-contents">
                  <div className="title">Contents Include:</div>
                  <div className="list">
                   { data.allWordpressPage.edges[0].node.acf.contents_include_box.items.map((item, i) => {
                      return(
                        <div className="list-item">—   {item.item}</div>
                      )
                   })}
                  </div>
                </div>
              </div>
              <div className={this.state.toggleData ? "hide-absolute grid lap-two-thirds" : "grid lap-two-thirds"}>
                <div className="preview-info">
                  <div className="video-component no-line-pad">
                    <div className="title">{data.allWordpressPage.edges[0].node.acf.intro_video_text}</div>

                      { data.allWordpressPage.edges[0].node.acf.video.video !== null &&
                        <VideoElement 
                          gatimeevents={1} 
                          galabel={'Intro University Video'} 
                          url={data.allWordpressPage.edges[0].node.acf.video.video}
                          controls={true}
                          autoPlay={false}
                          poster={data.allWordpressPage.edges[0].node.acf.video.video_poster.url}
                          loop={false}
                          playOverlay={false} 
                        />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={this.state.toggleData ? 'hide-absolute main-gutter gray password-wrapper' : 'main-gutter gray password-wrapper'}>
            <div className="inner">
            <div className="grid-wrapper">
              <div className="grid lap-one-half" data-aos="fade-up">
                <div className="">
                  <div className="password-header"  dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.password_protection_area.left_column_body }} />
                  <form className="login-univeristy">
                    <div className={this.state.passwordInvalid ? 'error input--wrapper' : 'input--wrapper'}>
                      <label htmlFor="name" className={" " + (this.state.password ? 'active' : '')}>enter email here</label>
                      <input id="emailAddressFormID" type="email" name="email" onChange={this.handlePasswordChange} onKeyDown={(e) => this.onKeyDown(e)}/>
                      <div className="name error inactive">Email does not exist, please try again.</div>
                    </div>
                   
                    <span className="cta password submit" onClick={(e) => this.handleSubmit(e)} tabIndex="0">Submit<span><span></span></span></span>
                  </form>
                </div>
              </div>
              <div className="grid lap-one-half" data-aos="fade-up" data-aos-delay="300">
                <div className="content">
                  <div className="wysiwyg" dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.password_protection_area.right_column_body }} />
                </div>
              </div>
            </div>
            </div>
          </div>
          { this.state.toggleData &&
            <div className="categories--wrapper">
              <div className="inner">
              { this.props.data.allWordpressWpUniversityCategories.edges.map(( edge, i) => {
                return(
                  <div>
                  { edge.node.wordpress_parent == 0 &&
                    <div key={edge.node.slug} className={this.state.toggleData ? 'university-item' : 'hide-absolute university-item'} data-aos="fade-up" data-aos-delay="1200" data-aos-anchor=".categories--wrapper">
                    <div className="cateogry-title" dangerouslySetInnerHTML={{__html: edge.node.name}} />
                    
                    { this.props.data.allWordpressWpUniversityCategories.edges.map(( innerCategories, i) => {
                      // start secondary inner categories search
                      if(edge.node.wordpress_id == innerCategories.node.wordpress_parent){
                        return(
                          <div>
                            <div className="cateogry-subtitle" dangerouslySetInnerHTML={{__html: innerCategories.node.name}} /> 
                            <div className="grid-wrapper">
                              { this.props.data.allWordpressWpUniversity.edges.map(( resource, i) => {

                                if(resource.node.university_categories.includes(innerCategories.node.wordpress_id)){
                                  return(
                                    <div className="grid lap-one-third">
                                    { resource.node.acf.body_information.coming_soon === 'yes' &&
                                      
                                        <div className="content--wrapper">
                                          <div className="content">
                                            <div className="image-wrapper">
                                            { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                              resource.node.acf.body_information.pdf_preview_image !== null && 
                                              resource.node.acf.body_information.pdf_preview_image.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.pdf_preview_image.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.pdf_preview_image.url}
                                                    alt={resource.node.acf.body_information.pdf_preview_image.alt} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                resource.node.acf.body_information.video.video_poster !== null && 
                                                resource.node.acf.body_information.video.video_poster.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.video.video_poster.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.video.video_poster.url} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video.video_poster === null && 
                                                resource.node.acf.body_information.pdf_preview_image === null &&
                                                <div className="image" style={{'backgroundImage': "url(" + data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url + ")"}}>
                                                  <img
                                                    src={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url}
                                                    alt={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.alt} />
                                                </div>
                                              }
                                              
                                            </div>
                                            <div className="info">
                                             <span className="info__title">{ resource.node.title }</span>
                                             <div className="info__svg">
                                              { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                <span className="info__svg-descriptor">PDF</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                <span className="info__svg-descriptor">Video</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                  <svg width="11px" height="13px" viewBox="0 0 11 13" version="1.1">
                                                      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                          <g id="University-Logged-In---Desktop" transform="translate(-489.000000, -1399.000000)">
                                                              <g id="Group-14-Copy-17" transform="translate(489.000000, 1399.000000)">
                                                                  <rect id="Rectangle" fill="#0B1C3E" x="0" y="0" width="11" height="13"></rect>
                                                                  <polyline id="Shape" fill="#FFFFFF" points="9 7 9 11 5 11"></polyline>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </svg>
                                                }
                                                { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                  <svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1">
                                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                      <g id="University-Logged-In---Desktop" transform="translate(-485.000000, -727.000000)" fill="#0B1C3E">
                                                        <g id="Group-2" transform="translate(485.000000, 727.000000)">
                                                          <rect id="Rectangle-Copy-3" x="0" y="0" width="11" height="10"></rect>
                                                          <polyline id="Path-Copy-2" transform="translate(14.707107, 5.000000) rotate(-315.000000) translate(-14.707107, -5.000000) " points="18.2071068 8.5 11.2071068 8.5 11.2071068 1.5 11.2071068 1.5"></polyline>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </svg>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    }
                                    { resource.node.acf.body_information.coming_soon === 'no' &&
                                       
                                        <div className="content--wrapper hover" onClick={() => this.updateData(resource.node.wordpress_id, resource.node.title, resource.node.acf.body_information)}>
                                          <div className="content">
                                            <div className="image-wrapper">
                                            { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                              resource.node.acf.body_information.pdf_preview_image !== null && 
                                              resource.node.acf.body_information.pdf_preview_image.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.pdf_preview_image.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.pdf_preview_image.url}
                                                    alt={resource.node.acf.body_information.pdf_preview_image.alt} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                resource.node.acf.body_information.video.video_poster !== null && 
                                                resource.node.acf.body_information.video.video_poster.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.video.video_poster.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.video.video_poster.url} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video.video_poster === null && 
                                                resource.node.acf.body_information.pdf_preview_image === null &&
                                                <div className="image" style={{'backgroundImage': "url(" + data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url + ")"}}>
                                                  <img
                                                    src={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url}
                                                    alt={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.alt} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                resource.node.acf.body_information.pdf_size !== '' &&
                                                <span className="file-size">{resource.node.acf.body_information.pdf_size}</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                resource.node.acf.body_information.video.video_duration !== '' &&
                                                <span className="file-size">{resource.node.acf.body_information.video.video_duration}</span>
                                              }
                                              <div className="show-fade"></div>
                                              <div className="show-svg-plus">
                                                <svg width="91px" height="91px" viewBox="0 0 91 91" version="1.1">
                                                  <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="University-Logged-In---Desktop" transform="translate(-675.000000, -640.000000)" stroke="#FFFFFF">
                                                      <g id="Group-9" transform="translate(677.000000, 642.000000)">
                                                        <g id="Oval-2" stroke-width="3">
                                                          <circle id="Oval" cx="43.5" cy="43.5" r="43.5"></circle>
                                                        </g>
                                                        <g id="Group-3-Copy-2" transform="translate(33.000000, 33.000000)" stroke-linecap="square" stroke-width="2">
                                                          <path d="M21.75,10.75 L0.75,10.25" id="Line-5-Copy-8"></path>
                                                          <path d="M11.5,0 L11,21" id="Line-5-Copy-8"></path>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </svg>
                                              </div>
                                            </div>
                                            <div className="info">
                                             <span className="info__title" dangerouslySetInnerHTML={{__html: resource.node.title}} />
                                             <div className="info__svg">
                                             { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                <span className="info__svg-descriptor">PDF</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                <span className="info__svg-descriptor">Video</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                  <svg width="11px" height="13px" viewBox="0 0 11 13" version="1.1">
                                                      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                          <g id="University-Logged-In---Desktop" transform="translate(-489.000000, -1399.000000)">
                                                              <g id="Group-14-Copy-17" transform="translate(489.000000, 1399.000000)">
                                                                  <rect id="Rectangle" fill="#0B1C3E" x="0" y="0" width="11" height="13"></rect>
                                                                  <polyline id="Shape" fill="#FFFFFF" points="9 7 9 11 5 11"></polyline>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </svg>
                                                }
                                                { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                  <svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1">
                                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                      <g id="University-Logged-In---Desktop" transform="translate(-485.000000, -727.000000)" fill="#0B1C3E">
                                                        <g id="Group-2" transform="translate(485.000000, 727.000000)">
                                                          <rect id="Rectangle-Copy-3" x="0" y="0" width="11" height="10"></rect>
                                                          <polyline id="Path-Copy-2" transform="translate(14.707107, 5.000000) rotate(-315.000000) translate(-14.707107, -5.000000) " points="18.2071068 8.5 11.2071068 8.5 11.2071068 1.5 11.2071068 1.5"></polyline>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </svg>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  )
                                }else{
                                  
                                }
                              })}
                            </div>
                           </div>
                        )
                        // end secondary inner categories search
                      }else if(reducedArray.includes(edge.node.wordpress_id)){
                        return(
                          <div className="grid-wrapper">
                            { this.props.data.allWordpressWpUniversity.edges.map(( resource, i) => {
                              if(resource.node.university_categories.includes(edge.node.wordpress_id) && !finalLoopedElements.includes(resource.node.university_categories)){
                                finalLoopedElements.push(resource.node.university_categories)
                                return(
                                  <div className="grid lap-one-third">
                                    { resource.node.acf.body_information.coming_soon === 'yes' &&
                                      
                                        <div className="content--wrapper">
                                          <div className="content">
                                          <div className="image-wrapper">
                                            { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                              resource.node.acf.body_information.pdf_preview_image !== null && 
                                              resource.node.acf.body_information.pdf_preview_image.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.pdf_preview_image.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.pdf_preview_image.url}
                                                    alt={resource.node.acf.body_information.pdf_preview_image.alt} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                resource.node.acf.body_information.video.video_poster !== null && 
                                                resource.node.acf.body_information.video.video_poster.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.video.video_poster.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.video.video_poster.url} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video.video_poster === null && 
                                                resource.node.acf.body_information.pdf_preview_image === null &&
                                                <div className="image" style={{'backgroundImage': "url(" + data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url + ")"}}>
                                                  <img
                                                    src={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url}
                                                    alt={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.alt} />
                                                </div>
                                              }
                                            </div>
                                            <div className="info">
                                             <span className="info__title">{ resource.node.title }</span>
                                             <div className="info__svg">
                                             { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                <span className="info__svg-descriptor">PDF</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                <span className="info__svg-descriptor">Video</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                  <svg width="11px" height="13px" viewBox="0 0 11 13" version="1.1">
                                                      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                          <g id="University-Logged-In---Desktop" transform="translate(-489.000000, -1399.000000)">
                                                              <g id="Group-14-Copy-17" transform="translate(489.000000, 1399.000000)">
                                                                  <rect id="Rectangle" fill="#0B1C3E" x="0" y="0" width="11" height="13"></rect>
                                                                  <polyline id="Shape" fill="#FFFFFF" points="9 7 9 11 5 11"></polyline>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </svg>
                                                }
                                                { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                  <svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1">
                                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                      <g id="University-Logged-In---Desktop" transform="translate(-485.000000, -727.000000)" fill="#0B1C3E">
                                                        <g id="Group-2" transform="translate(485.000000, 727.000000)">
                                                          <rect id="Rectangle-Copy-3" x="0" y="0" width="11" height="10"></rect>
                                                          <polyline id="Path-Copy-2" transform="translate(14.707107, 5.000000) rotate(-315.000000) translate(-14.707107, -5.000000) " points="18.2071068 8.5 11.2071068 8.5 11.2071068 1.5 11.2071068 1.5"></polyline>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </svg>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    }
                                    { resource.node.acf.body_information.coming_soon === 'no' &&
                                      
                                        <div className="content--wrapper hover" onClick={() => this.updateData(resource.node.wordpress_id, resource.node.title, resource.node.acf.body_information)}>
                                          <div className="content">
                                            <div className="image-wrapper">
                                            { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                              resource.node.acf.body_information.pdf_preview_image !== null && 
                                              resource.node.acf.body_information.pdf_preview_image.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.pdf_preview_image.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.pdf_preview_image.url}
                                                    alt={resource.node.acf.body_information.pdf_preview_image.alt} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                              resource.node.acf.body_information.video.video_poster !== null && 
                                                resource.node.acf.body_information.video.video_poster.url !== "" &&
                                                <div className="image" style={{'backgroundImage': "url(" + resource.node.acf.body_information.video.video_poster.url + ")"}}>
                                                  <img
                                                    src={resource.node.acf.body_information.video.video_poster.url} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video.video_poster === null && 
                                                resource.node.acf.body_information.pdf_preview_image === null &&
                                                <div className="image" style={{'backgroundImage': "url(" + data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url + ")"}}>
                                                  <img
                                                    src={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.url}
                                                    alt={data.allWordpressAcfOptions.group[0].edges[0].node.options.university_module_fallback_image.alt} />
                                                </div>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                resource.node.acf.body_information.pdf_size !== '' &&
                                                <span className="file-size">{resource.node.acf.body_information.pdf_size}</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                resource.node.acf.body_information.video_duration !== '' &&
                                                <span className="file-size">{resource.node.acf.body_information.video_duration}</span>
                                              }
                                              <div className="show-fade"></div>
                                              <div className="show-svg-plus">
                                                <svg width="91px" height="91px" viewBox="0 0 91 91" version="1.1">
                                                  <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="University-Logged-In---Desktop" transform="translate(-675.000000, -640.000000)" stroke="#FFFFFF">
                                                      <g id="Group-9" transform="translate(677.000000, 642.000000)">
                                                        <g id="Oval-2" stroke-width="3">
                                                          <circle id="Oval" cx="43.5" cy="43.5" r="43.5"></circle>
                                                        </g>
                                                        <g id="Group-3-Copy-2" transform="translate(33.000000, 33.000000)" stroke-linecap="square" stroke-width="2">
                                                          <path d="M21.75,10.75 L0.75,10.25" id="Line-5-Copy-8"></path>
                                                          <path d="M11.5,0 L11,21" id="Line-5-Copy-8"></path>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </svg>
                                              </div>
                                            </div>
                                            <div className="info">
                                             <span className="info__title" dangerouslySetInnerHTML={{__html: resource.node.title}} />
                                             <div className="info__svg">
                                             { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                <span className="info__svg-descriptor">PDF</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                <span className="info__svg-descriptor">Video</span>
                                              }
                                              { resource.node.acf.body_information.video_or_pdf === 'pdf' &&
                                                  <svg width="11px" height="13px" viewBox="0 0 11 13" version="1.1">
                                                      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                          <g id="University-Logged-In---Desktop" transform="translate(-489.000000, -1399.000000)">
                                                              <g id="Group-14-Copy-17" transform="translate(489.000000, 1399.000000)">
                                                                  <rect id="Rectangle" fill="#0B1C3E" x="0" y="0" width="11" height="13"></rect>
                                                                  <polyline id="Shape" fill="#FFFFFF" points="9 7 9 11 5 11"></polyline>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </svg>
                                                }
                                                { resource.node.acf.body_information.video_or_pdf === 'video' &&
                                                  <svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1">
                                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                      <g id="University-Logged-In---Desktop" transform="translate(-485.000000, -727.000000)" fill="#0B1C3E">
                                                        <g id="Group-2" transform="translate(485.000000, 727.000000)">
                                                          <rect id="Rectangle-Copy-3" x="0" y="0" width="11" height="10"></rect>
                                                          <polyline id="Path-Copy-2" transform="translate(14.707107, 5.000000) rotate(-315.000000) translate(-14.707107, -5.000000) " points="18.2071068 8.5 11.2071068 8.5 11.2071068 1.5 11.2071068 1.5"></polyline>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </svg>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  )
                                }
                              }
                            )
                          }
                          </div>
                          )
                      }})} 
                    </div>
                  }
                  </div>
                )
              })}
              </div>
            </div>
          }
          { this.state.overlayActive &&
            <div className={ this.state.overlayActive ? 'overlay active' : 'overlay'}>
              <div className="close-button-wrapper">
              	<div className="close-button" onClick={() => this.closeOverlay()}>
	                <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1">
	                  <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
	                    <g id="University---PDF-Lightbox" transform="translate(-1206.000000, -194.000000)" stroke="#0B1C3E">
	                      <g id="Video-Lightbox">
	                        <g id="Group-17" transform="translate(1207.000000, 195.000000)">
	                          <g id="Group">
	                            <g id="Group-3-Copy-2" transform="translate(25.000000, 24.500000) rotate(-315.000000) translate(-25.000000, -24.500000) translate(14.000000, 14.000000)" stroke-linecap="square" stroke-width="2">
	                              <path d="M21.75,10.75 L0.75,10.25" id="Line-5-Copy-8"></path>
	                              <path d="M11.5,0 L11,21" id="Line-5-Copy-8"></path>
	                            </g>
	                            <circle id="Oval" cx="25" cy="25" r="25"></circle>
	                          </g>
	                        </g>
	                      </g>
	                    </g>
	                  </g>
	                </svg>
	              </div>
              </div>
              <div className="overlay--inner">
                <div className="content">
                  <div className="video-component no-top">
                    <div className="inner">
                      <div className="title" dangerouslySetInnerHTML={{__html: this.state.overlayTitle}} />
                      <div className="wysiwyg" dangerouslySetInnerHTML={{__html: this.state.overlayBody}} />
                      { this.state.overlayPDForVideo == 'video' &&
                        this.state.overlaySourceURL && 
                        <VideoElement 
                          gatimeevents={1}  
                          url={this.state.overlaySourceURL} 
                          controls={true} 
                          autoPlay={false} 
                          poster={this.state.overlayPosterImage} 
                          loop={false} 
                          playOverlay={false} 
                        />
                      }
                      { this.state.overlayPDForVideo == 'pdf' &&
                        <div>
                          <img src={this.state.overlayPosterImage} />
                          <a target="_blank" className="download-item" href={this.state.overlaySourceURL} download={this.state.overlayTitle}>Download PDF</a>
                        </div>
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          { this.state.validatedData.length > 0 &&
            data.allWordpressPage.edges[0].node.acf.glosssary.items.length > 0 &&
            <div className="glossary" data-aos="fade-up">
              <div className="glosssary--inner">
                <div className="h2" data-aos="fade-up">{data.allWordpressPage.edges[0].node.acf.glosssary.title}</div>
                <div className="grid-wrapper">
                  { data.allWordpressPage.edges[0].node.acf.glosssary.items.map(( node ) => (
                      <div className="grid lap-one-half" data-aos="fade-up">
                        <div className="glossary__title" dangerouslySetInnerHTML={{__html: node.item_title}}></div>
                        <div className="glossary__body" dangerouslySetInnerHTML={{__html: node.item_wysiwyg}}></div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          }
          { this.state.validatedData.length > 0 &&
            data.allWordpressPage.edges[0].node.acf.contact_us_module.body_information.length > 0 &&
            <div className="contact-us-univeristy">
              <div className="inner">
                <div className="h2">
                  { data.allWordpressPage.edges[0].node.acf.contact_us_module.title }
                </div>
                <div className="grid-wrapper">
                  <div className="grid lap-one-half" >
                    <div className="flag a" data-aos="draw-line" data-aos-delay="150">
                      <svg width="125px" height="10px" viewBox="0 0 125 10">
                        <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="About---Desktop" transform="translate(-140.000000, -1460.000000)" fill="#FFFFFF">
                            <g id="Group" transform="translate(140.000000, 1460.000000)">
                              <polygon id="Rectangle-Copy-6" points="0 0 120.192308 0 125 5 120.192308 10 0 10 4.20673077 5"></polygon>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <div className="line">

                      </div>
                    </div>
                  </div>
                  <div className="grid lap-one-half" data-aos="fade-up" data-aos-delay="300">
                    <div className="body" dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.contact_us_module.body_information}} />
                    <a className="cta contact white-text" href={data.allWordpressPage.edges[0].node.acf.contact_us_module.cta.url}>{data.allWordpressPage.edges[0].node.acf.contact_us_module.cta.title}<span><span></span></span></a>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </Layout>
    )
    }
  }
}

export default University

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    allWordpressAcfOptions {
      group(field: id) {
        edges {
          node {
            options {
              meta_data_by_page {
                university {
                  image {
                    alt
                    url
                  }
                }
              }
              university_module_fallback_image {
                url
                alt
              }
            }
          }
        }
      }
    }
    allWordpressPage(filter: {template: {eq: "university.php"}}) {
      edges {
        node {
          acf {
            headline
            subheadline
            preheadline
            intro_video_text
            video {
              video
              video_poster {
                alt
                url
              }
            }
            contents_include_box {
              title
              items {
                item
              }
            }
            password_protection_area {
              left_column_body
              right_column_body
            }
            glosssary {
              items {
                item_title
                item_wysiwyg
              }
              title
            }
            contact_us_module {
              body_information
              cta {
                target
                url
                title
              }
              title
            }
          }
        }
      }
    }
    allWordpressWpUniversityCategories(sort: {fields: slug}, filter: {}) {
      edges {
        node {
          wordpress_id
          slug
          name
          wordpress_parent
        }
      }
    }
    allWordpressWpUniversity(sort: {fields: menu_order}) {
      edges {
        node {
          title
          slug
          university_categories
          wordpress_id
          acf {
            body_information {
              coming_soon
              pdf_size
              pdf_url
              video_or_pdf
              wysiwyg
              video {
                video
                video_poster {
                  url
                }
                video_duration
              }
              pdf_preview_image {
                url
                alt
              }
            }
          }
        }
      }
    }
  }
`
